import MovementApp from './MovementApp.jsx';
import RobotronApp from './Robotron/RobotronApp.jsx';
import { Routes, Route, useResolvedPath, useLocation  } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import About from './About.jsx';
import Download from './Download.jsx';
import Chat from './Chat.jsx';
import History from './History.jsx';
import Faq from './Faq.jsx';

import RoboAbout from './Robotron/RoboAbout.jsx';
import RoboDownload from './Robotron/RoboDownload.jsx';
import Game from './Robotron/Game.jsx';
import HighScores from './Robotron/HighScores.jsx';
import WellDone from './Robotron/WellDone.jsx';

import './App.css';


function App() {

  const [windowX, setWindowX] = useState(window.innerWidth);
  const [windowY, setWindowY] = useState(window.innerHeight);
  
  if (windowY > 1260) {
    document.body.style.overflowY = "hidden"
  } else {
    document.body.style.overflowY = "scroll"
  }
  if (windowX > 800) {
    document.body.style.overflowX = "hidden"
  } else {
    document.body.style.overflowX = "scroll"
  }

  React.useEffect(() => {
    const handleResize = () => {
      setWindowX(window.innerWidth)
      setWindowY(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)
  })

  const borderWidth = Math.max(0,Math.min(200, windowX - 1000))

  const mainBoxWidth = Math.min(1700,Math.max(800, windowX-borderWidth))
  const mainBoxHeight = Math.max(1000, windowY-260)

  const headerStyle = {zIndex: "999", color:"white", margin:0, fontFamily: "Terminal", fontSize:15, float:"left", textAlign:"left"}

  return <div>
          


          <Routes>
            <Route path="robotron" element={
              <RobotronApp
                mainBoxHeight={mainBoxHeight}
                mainBoxWidth={mainBoxWidth}
                borderWidth={borderWidth}
                windowX={windowX}
                windowY={windowY}/>
            }>

              <Route path="download" element={
                <RoboDownload mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="game" element={
                <Game mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="highscores" element={
                <HighScores mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="welldone" element={
                <WellDone mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="" element={
                <RoboAbout mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />

            </Route>
            <Route path="" element={
              <MovementApp 
                mainBoxHeight={mainBoxHeight}
                mainBoxWidth={mainBoxWidth}
                borderWidth={borderWidth}
                windowX={windowX}
                windowY={windowY}/>
            }>

              <Route path="download" element={
                <Download mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="chat" element={
                <Chat mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="history" element={
                <History mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="faq" element={
                <Faq mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />
              <Route path="" element={
                <About mainBoxHeight={mainBoxHeight} mainBoxWidth={mainBoxWidth}/>
              } />

            </Route>
          </Routes>
          <div className={"footer"}>
            <div className={"footerItem"}><a href="/">Movement</a></div>
            <div className={"footerItem"}><a href="/robotron">Robotron</a></div>
            <div className={"footerItem"}><a href="/shs">SHS</a></div>
          </div>
        </div>
       
  ;
}

export default App;
